import { CalendarEvent, CalendarEventExtendedProps } from './types';
import { ContextActionEvent, WaitListContextActionEvent, ShelfContextActionEvent } from './types';

/**
 * Adapts a context action (non-persisted) pseudo event into a CalendarEvent
 * so the rest of the system (ContextMenu, controller) can treat it uniformly.
 */
export const adaptContextActionToCalendarEvent = (action: ContextActionEvent): CalendarEvent => {
  const baseExtended: CalendarEventExtendedProps = {
    eventType: 'timeslot', // treat as timeslot for uniform menu logic
    timeSlotType: action.kind as any, // extend existing union at runtime
    multipleTimeSlots: false,
    containsHeatTreatment: false,
    hasNotes: false,
    isCancelled: false,
    isContinuous: undefined as any, // 
  };

  return {
    id: action.id,
    title: '',
    start: action.start,
    resourceId: action.resourceId,
    allDay: false,
    extendedProps: baseExtended,
  };
};

export const buildWaitListContextAction = (start: string, resourceId?: string): WaitListContextActionEvent => {
  return {
    id: `waitlist-${resourceId || 'none'}-${start.toString()}`,
    kind: 'WaitList',
    start: start.toString(),
    resourceId,
  };
};

export const buildShelfContextAction = (start: string, resourceId?: string): ShelfContextActionEvent => {
  return {
    id: `shelf-${resourceId || 'none'}-${start}`,
    kind: 'ShelfEvent',
    start: start,
    resourceId,
  };
};
